import { render, staticRenderFns } from "./BallotEntryFooter.vue?vue&type=template&id=b576e552&"
import script from "./BallotEntryFooter.vue?vue&type=script&lang=js&"
export * from "./BallotEntryFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports